import { map } from 'rxjs';
import { convertUnixToDate } from '@golden/utils';
import { ADMIN_API } from '../AdminAPI';
export function createPermissionRoleService(api) {
    return {
        getRoleTree(id) {
            return api.fetch(ADMIN_API.GET_ROLE_TREE, { data: { id } })
                .pipe(map((res) => res.map((el) => convertUnixToDate(el, 'created_at'))));
        },
        getRoleList(id, page) {
            return api.fetch(ADMIN_API.GET_ROLE_LIST, { data: { id, page } })
                .pipe(map((res) => ({
                ...res,
                self_data: convertUnixToDate(res.self_data, 'updated_at'),
                data: res.data.map((el) => convertUnixToDate(el, 'updated_at'))
            })));
        },
        getRole(id) {
            return api.fetch(ADMIN_API.GET_ROLE, { config: { urlParams: { id } } });
        },
        createRole(data) {
            return api.fetch(ADMIN_API.POST_ROLE, { data });
        },
        updateRole(id, data) {
            return api.fetch(ADMIN_API.PUT_ROLE, { data, config: { urlParams: { id } } });
        },
        deleteRole(id) {
            return api.fetch(ADMIN_API.DEL_ROLE, { config: { urlParams: { id } } });
        }
    };
}
//# sourceMappingURL=PermissionRoleService.js.map